<template>
  <div class="page-not-found">
    <TheAppBar />

    <v-content transition="out-in">
      <v-container>
        <v-row>
          <v-col>
            <h1 class="text-center">404</h1>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import TheAppBar from '@/components/TheAppBar.vue';

export default {
  metaInfo: {
    title: 'Page not found - 404',
  },

  components: {
    TheAppBar,
  },
};
</script>

<style lang="scss" scoped></style>
